import logo from './logo.svg';
import './App.css';
import ImageConverter from './pages/imageConverter.jsx';

function App() {
  return (
    <div className="App">

        <ImageConverter/>
    </div>
  );
}

export default App;
